/** Texto estável para o comprador — nunca incluir detalhe do PSP. */
export const CHECKOUT_PUBLIC_ERROR_MESSAGE =
  'Não foi possível concluir o pagamento agora. Tente novamente em alguns instantes.';
